import axios from "axios";
import { useState, useEffect, useCallback } from "react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: BASE });

export const fetchProjects = () => api.get("/projects").then((r) => r.data);
export const fetchProject = (id) => api.get(`/projects/${id}`).then((r) => r.data);
export const fetchTasks = () => api.get("/tasks").then((r) => r.data);
export const fetchCustomers = () => api.get("/customers").then((r) => r.data);
export const fetchTeam = () => api.get("/team").then((r) => r.data);
export const fetchDocuments = () => api.get("/documents").then((r) => r.data);
export const fetchDashboard = () => api.get("/dashboard").then((r) => r.data);
export const refreshCache = () => api.post("/refresh").then((r) => r.data);

// Chat & notifications
export const fetchChat = (scope, refId) => api.get(`/chat`, { params: { scope, refId } }).then((r) => r.data);
export const postChat = (payload) => api.post(`/chat`, payload).then((r) => r.data);
export const fetchNotifications = (userId) => api.get(`/notifications/${userId}`).then((r) => r.data);
export const markNotificationsRead = (userId, ids) => api.post(`/notifications/${userId}/read`, { ids: ids || null }).then((r) => r.data);

// Generic data-fetching hook with loading / error state
export function useApi(fn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    fn()
      .then((d) => setData(d))
      .catch((e) => setError(e?.response?.data?.detail || e.message || "Request failed"))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => { load(); }, [load]);
  return { data, loading, error, reload: load };
}
